import { Badge, IconButton, Tooltip, Menu, MenuItem } from "@mui/material";
import React, { useState, useEffect } from "react";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";

export default function ImageUploaderIconButton({
  imageFiles,
  setImageFiles,
  addImage,
  numImages,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [hasClipboardImage, setHasClipboardImage] = useState(false);

  const open = Boolean(anchorEl);

  // Check clipboard for images
  const checkClipboard = async () => {
    try {
      // Clipboard API requires a secure context (https)
      const clipboardItems = await navigator.clipboard.read();
      const imageItem = clipboardItems.find(item =>
        item.types.includes("image/png") || item.types.includes("image/jpeg")
      );
      setHasClipboardImage(Boolean(imageItem));
    } catch (err) {
      // Clipboard access may fail if not triggered by user gesture
      setHasClipboardImage(false);
    }
  };

  useEffect(() => {
    checkClipboard();
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    checkClipboard(); // refresh clipboard check when menu opens
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) convertToBase64(file);
    event.target.value = null;
    handleClose();
  };

  const handlePaste = async () => {
    try {
      const clipboardItems = await navigator.clipboard.read();
      for (const item of clipboardItems) {
        for (const type of item.types) {
          if (type.startsWith("image/")) {
            const blob = await item.getType(type);
            convertToBase64(blob);
            break;
          }
        }
      }
    } catch (err) {
      console.error("Failed to read clipboard contents: ", err);
    }
    handleClose();
  };

  const convertToBase64 = (fileOrBlob) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      addImage({
        name: fileOrBlob.name || "clipboard-image",
        base64: reader.result,
      });
    };
    reader.readAsDataURL(fileOrBlob);
  };

  return (
    <>
      <Tooltip title="add image" placement="top">
        <IconButton onClick={handleClick}>
          <Badge badgeContent={numImages} color="primary">
            <AddPhotoAlternateIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {hasClipboardImage && <MenuItem onClick={handlePaste}>Paste Image</MenuItem>}
        <MenuItem>
          <label style={{ cursor: "pointer", width: "100%" }}>
            Select Image
            <input
              type="file"
              onChange={handleFileChange}
              hidden
              accept="image/*"
            />
          </label>
        </MenuItem>
      </Menu>
    </>
  );
}
